import { render, staticRenderFns } from "./aff-member.vue?vue&type=template&id=7d48278a"
import script from "./aff-member.vue?vue&type=script&lang=js"
export * from "./aff-member.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d48278a')) {
      api.createRecord('7d48278a', component.options)
    } else {
      api.reload('7d48278a', component.options)
    }
    module.hot.accept("./aff-member.vue?vue&type=template&id=7d48278a", function () {
      api.rerender('7d48278a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/user-aff/aff-member.vue"
export default component.exports